<template>
	<div class="login-background">
		<div class="login-right">
			<div class="login-center-wrap">
				<!-- <div id="loginCenterLeft" class="vhalf fleft flex-center">
					<ul class="login-edc-list no-drag">
						<li></li>
						<li></li>
						<li></li>
						<li></li>
						<li></li>
					</ul>
				</div> -->
				<div id="loginCenterRight">
					<form class="login-form" @submit.prevent="doLogin">
						<!-- <img class="login-head" src="@/assets/images/login/login_head.png" alt=""/> -->
						<!-- <label for="userId" class="login-form-label flex-center">
							<img src="@/assets/images/login/id_icon_login.png" alt="" />
							User ID
						</label> -->
						<span class="login-name bold">로그인</span>
						<!-- <div class="login-mode">
							<button type="button" :class="isMode == 1 ? 'mode' : ''" @click="selectMode(1)">모니터링 담당자</button>
							<button type="button" :class="isMode == 2 ? 'mode' : ''" @click="selectMode(2)">코디네이터</button>
						</div> -->
						<input
							type="text"
							id="userId"
							v-model="userId"
							ref="userId"
							class="input-login-style sha-focus-666 bmargin-15"
							placeholder="아이디"
							autocomplete="off"
							v-validate="'required|min:4'"
							data-vv-name="UserID"
							style="margin-top: 2.2vh"
						/>

						<!-- <label for="password" class="login-form-label flex-center">
							<img src="@/assets/images/login/pw_icon_login.png" alt="" />
							PASSWORD
						</label> -->
						<input
							type="password"
							id="password"
							v-model="password"
							ref="password"
							class="input-login-style sha-focus-666"
							placeholder="비밀번호"
							autocomplete="off"
							v-validate="'required|min:6'"
							data-vv-name="Password"
							@keydown.enter="doLogin"
							style="margin-top: 1vh;"
						/>

						<button type="button" class="login-button" @click="doLogin">
							로그인
						</button>

						<!-- <div class="login-form-bottom">
							<button type="button" class="button-line-white fleft" @click.prevent="signUp()">
								Sign up
							</button>
							<button type="button" class="button-line-white fright" @click.prevent="findUser()">
								Find Account
							</button>
						</div> -->

						<div class="login-sub">
							<button type="button" @click.prevent="findUser(1)">아이디찾기</button>
							<div>|</div>
							<button type="button" @click.prevent="findUser(2)">비밀번호 찾기</button>
							<div>|</div>
							<button type="button" @click.prevent="signUp()">회원가입</button>
						</div>

						<!-- <div class="login-call">
							<span>Customer Service</span>
							<span style="font-weight: bold; color:#004098;">070-800-8000</span>
						</div> -->

						<!-- <div class="login-sponser">
							<img style="width: 5.37vmax;" src="@/assets/images/login/agency_img_1.png" alt=""/>
							<img style="width: 4.54vmax;" src="@/assets/images/login/agency_img_3.png" alt=""/>
							<img style="width: 5.94vmax;" src="@/assets/images/login/agency_img_4.png" alt=""/>
						</div> -->
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import VeeValidator from "vee-validate";
import EventBus from "@/script/EventBus.js";
Vue.use(VeeValidator);

export default {
	name: "Login",
	created() {
		this.logger.debug(this, ".created()");
		console.log(this.userInfo.userId);
		if (!this.utils.isEmpty(this.userInfo.userId)) {
			this.$router.push(this.config.contextRoot + "/home");
		}
		EventBus.$emit("project-loading", false);
	},
	mounted() {
		this.logger.debug(this, ".mounted()");
	},
	data() {
		return {
			userId: "",
			password: "",
			loginResult: false,
			findId: "N",
			findPass: "N",
			isMode: 1,
		};
	},
	methods: {
		selectMode(code){
			if(code == 1){ this.isMode = 1;}
			else{this.isMode = 2;}
		},
		doLogin() {
			this.logger.debug(this, "doLogin");

			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "valid:" + result);
					if (!result) {
						return;
					}

					this.$Auth.login(
						this.userId,
						this.password,
						function(loginResult) {
							if (loginResult) {
								this.$router.replace(
									this.$route.query.redirect || this.config.contextRoot + "/home"
								);
								this.$router.go(0);
							} else {
								this.logger.debug(this, "loginResult:" + loginResult);
							}
						}.bind(this)
					);
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					this.$alert(this.errors.all());
					return false;
				});
		},
		signUp() {
			this.logger.debug(this, ".signUp()");
			this.$router.push(this.config.contextRoot + "/login/sign/agree");
		},
		findUser(code) {
			this.logger.debug(this, ".findUser()");
			if(code == 1){
				this.$router.push(this.config.contextRoot + "/login/find/account/id");
			}
			else{
				this.$router.push(this.config.contextRoot + "/login/find/account/password");
			}
		},
	},
};
</script>
<style>
@import '../../assets/css/login/login.css';
</style>